const saturationQuantite = [
  { saturation: 1, quantiteDispo: 1 },
  { saturation: 2, quantiteDispo: 0.5 },
  { saturation: 3, quantiteDispo: 0.33 },
  { saturation: 4, quantiteDispo: 0.25 },
  { saturation: 5, quantiteDispo: 0.2 },
  { saturation: 6, quantiteDispo: 0.17 },
  { saturation: 7, quantiteDispo: 0.14 },
  { saturation: 8, quantiteDispo: 0.13 },
  { saturation: 9, quantiteDispo: 0.11 },
  { saturation: 10, quantiteDispo: 0.10 },
  { saturation: 11, quantiteDispo: 0.09 },
  { saturation: 12, quantiteDispo: 0.08 },
];

export function toQuantiteDispo(saturation) {
  if (!saturation || saturation === undefined) {
    return 0;
  }
  const elementTrouve = saturationQuantite.find((sq) => {
    return sq.saturation === saturation;
  });
  if (elementTrouve) return elementTrouve.quantiteDispo;
  return 0;
}

export function toSaturation(quantiteDispo) {
  if (!quantiteDispo || quantiteDispo === undefined) {
    return 0;
  }
  const elementTrouve = saturationQuantite.find((sq) => {
    return sq.quantiteDispo === quantiteDispo;
  });
  if (elementTrouve) return elementTrouve.saturation;
  return 0;
}
